import styled, { css } from 'styled-components/macro'
import { theme } from 'styled-tools'

import { em, rem, rgba } from '../../utils/styles'

const fontSize = em(16)
const padding = css`${rem(9)} ${rem(16)}`
const border = css`${rem(1)} solid ${rgba('base', 0.3)}`
const weight = theme('fontWeights.regular')
const color = theme('colors.base')

const focusBg = rgba('base', 0.1)

export const baseStyles = css`
  display: block;
  box-sizing: border-box;
  margin: 0;
  border: 0;
  padding: ${padding};
  width: 100%;
  background: none;
  color: ${color};
  font-weight: ${weight};
  font-size: ${fontSize};
  vertical-align: middle;
  line-height: 1;
  text-align: left;
  overflow: visible;

  &:disabled {
    opacity: .7;
    cursor: not-allowed;
  }

  &:not(:disabled) {
    cursor: pointer;
  }

  &:focus {
    outline: 0;
  }

  &:not(:disabled) {
    &:focus {
      background-color: ${focusBg};
    }

    &:hover {
      background-color: ${focusBg};
    }
  }

  * + & {
    border-top: ${border};
  }
`

export const MenuItem = styled.button`
  ${baseStyles}
`

export const MenuItemLink = styled.a`
  ${baseStyles}
  text-decoration: none;
`
